import { FC, useMemo, useState } from 'react';
import { HarmReportDetailsProps } from './harmReports.type';
import ReportDetails from '../../component/reportDetails/reportDetails';
import { createHarmReportConfig } from '../../component/reportDetails/harmReportConfig';
import { getHarmReportsKebabOptions } from './harmReportesHelper';
import { InterventionReportDetails } from '../interventionReports/interventionReportDetails';
import { InterventionReport } from '@inplay/models';
import { ReportService } from '../../service/reportService';
import { useOrganizationContext } from '../../service/context/organizationContext';
import ModalComponent from '../../component/modal/modal';
import Loading from '../../assets/loading/loading';

export const HarmReportDetails: FC<HarmReportDetailsProps> = (props) => {
  const { harmReport } = props;
  const config = createHarmReportConfig(harmReport);
  const { selectedVenueBranch } = useOrganizationContext();
  const reportService = useMemo(() => new ReportService(), []);
  const [viewingIntervention, setViewingIntervention] = useState<InterventionReport | null>(null);
  const [loadingLinkedReport, setLoadingLinkedReport] = useState<boolean>(false);

  const handleLinkedReportClick = async (reportId: string) => {
    if (!selectedVenueBranch) return;
    setLoadingLinkedReport(true);
    try {
      const response = await reportService.getInterventionReports({
        venueBranchId: selectedVenueBranch._id,
        currentDate: new Date(),
      });
      const reports: InterventionReport[] = response.data?.reports ?? [];
      const found = reports.find((r) => r.originalReportId === reportId);
      if (found) setViewingIntervention(found);
    } catch (error) {
      console.error('[HarmReportDetails] Error fetching intervention report', error);
    } finally {
      setLoadingLinkedReport(false);
    }
  };

  return (
    <>
      <ReportDetails
        config={config}
        onClose={props.closeHarmReportDetails}
        onReviewAndSign={props.handleReviewAndSignClick}
        kebabOptions={getHarmReportsKebabOptions(harmReport, null, 0)
          .filter((o) => o.label !== 'View')
          .map((o) => ({
            label: o.label,
            optionKey: o.label,
          }))}
        onKebabAction={props.onKebabAction}
        onLinkedReportClick={props.onKebabAction ? handleLinkedReportClick : undefined}
      />
      {loadingLinkedReport && !viewingIntervention && (
        <ModalComponent
          onToggle={() => setLoadingLinkedReport(false)}
          open={true}
          title=""
          isShowClose
          footerHidden
          dialogClassName="w-full max-w-[900px] h-[90vh] overflow-hidden"
        >
          <div className="flex justify-center items-center h-[calc(90vh-100px)]">
            <Loading />
          </div>
        </ModalComponent>
      )}
      {viewingIntervention && (
        <InterventionReportDetails
          interventionReport={viewingIntervention}
          onClose={() => setViewingIntervention(null)}
          onReviewAndSign={() => setViewingIntervention(null)}
        />
      )}
    </>
  );
};
